
import { InaSchoolEnrollmentSelection, LstQuestionValueDataView, Question, Section } from "../model/ina-school-enrollment-sections";
import { LastGradeAttendeds, RelationToChild } from "../model/relation-To-Child";
import { TrackingHistory } from "./history";
import { InaService } from "./ina.service";


export class Shared {

  lstRelationToChild: RelationToChild[] = [];
  lstLastGradeAttendeds: LastGradeAttendeds[] = [];

  inaSchoolEnrollmentSelection: InaSchoolEnrollmentSelection = new InaSchoolEnrollmentSelection();

  constructor(private inaService: InaService) {
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.inaSchoolEnrollmentSelection = x;
    })
  }
  eligibleNAtoAd: string[] = ['NA', 'AD'];
  eligibleP3toP5: string[] = ['P3', 'P4', 'P5', 'TK'];
  eligibleKto8: string[] = ['K', '01', '02', '03', '04', '05', '06', '07', '08'];
  eligible9to12: string[] = ['09', '10', '11', '12'];

  getRelationships(): RelationToChild[] {
    this.lstRelationToChild = [
      { name: '' },
      { name: 'mother/step-mother' },
      { name: 'father/step-father' },
      { name: 'sister' },
      { name: 'brother' },
      { name: 'grandmother' },
      { name: 'grandfather' },
      { name: 'aunt' },
      { name: 'uncle' },
      { name: 'cousin' },
      { name: 'relative' },
      { name: 'co-worker' },
      { name: 'friend' },
      { name: 'spouse' },
      { name: 'self' }

    ];
    return this.lstRelationToChild;
  }

  getLastGradeAttendeds(): LastGradeAttendeds[] {
    this.lstLastGradeAttendeds = [
      { name: 'Never Attended' },
      { name: 'Kindergarten' },
      { name: '01' },
      { name: '02' },
      { name: '03' },
      { name: '04' },
      { name: '05' },
      { name: '06' },
      { name: '07' },
      { name: '08' },
      { name: '09' },
      { name: '10' },
      { name: '11' },
      { name: '12' },
      { name: 'Adult Education' }
    ];
    return this.lstLastGradeAttendeds;
  }



  getQuestionValue(section: Section, questionId: number, questionName: string): string {
    let q = section.Questions.find(x => x.Id == questionId || x.Name == questionName)!;
    if (q.lstQuestionValueDataView[0].Type == 'RADIO BUTTON')
      return q.lstQuestionValueDataView.find(x => x.Value == 'True')?.Name!
    else //textArea or dropdown
      return q.lstQuestionValueDataView[0].Value;

  }
  getListQuestionValueData(section: Section, questionId: number, questionName: string): LstQuestionValueDataView[] {
    let q = section.Questions.find(x => x.Id == questionId || x.Name == questionName);
    if (q && q.Id > 0)
      return q?.lstQuestionValueDataView!;
    else {
      let q: LstQuestionValueDataView[] = [];
      return q;
    }
  }

  setRadioValue(section: Section, questionId: number, value: string) {
    let q = section.Questions.find(x => x.Id == questionId)!;
    if (q.lstQuestionValueDataView[0].Type == 'RADIO BUTTON') {
      q.lstQuestionValueDataView.forEach(x => {
        if (x.Type == 'RADIO BUTTON')
          x.Value = 'False';
      })
      if (value != "") {
        let index: number = Number(value);
        q.lstQuestionValueDataView[index - 1].Value = 'True';
      }
    }
    else //textArea or dropdown
      q.lstQuestionValueDataView[0].Value = value;

    this.updateSections(section,questionId);
  }

  setListQuestionValue(section: Section, questionId: number, questionName: string, value: string) {
    let q = section.Questions.find(x => x.Id == questionId)!;
    if (q.lstQuestionValueDataView.length == 1) {
      q.lstQuestionValueDataView[0].Value = value;
    }
    else {
      q.lstQuestionValueDataView.forEach(x => {
        if (x.Name == questionName) {
          x.Value = value;
        }
      })
    }

    this.updateSections(section,questionId);

  }

  setTrackingHistory(sec: Section, questionId: number, questionName: string, value: string): TrackingHistory {

    var questions: Question = sec.Questions.find(question => question.Id == questionId)!;
    //var lstDv: LstQuestionValueDataView[] = sec.Questions.find(question => question.Id == questionId)?.lstQuestionValueDataView!;
    var lstDv: LstQuestionValueDataView[] = questions.lstQuestionValueDataView;
    var qDv: LstQuestionValueDataView;
    if (questionName == '')
      qDv = lstDv.find(question => question.Id == questionId)!
    else
      qDv = lstDv.find(question => question.Name == questionName)!;

    let changedValue: string;
    if (qDv.Type == 'RADIO BUTTON') {
      let tmpPrevValue = lstDv.find(prevValue => prevValue.Value == "True");
      if (tmpPrevValue != null && tmpPrevValue?.Id >= 1)
        changedValue = questions.Name + ' (' + tmpPrevValue.Name + ')';
      else
        changedValue = questions.Name + ' (' + (value == 'True' || value == 'true' || value == '1' ? 'False' : 'True') + ')';
    }
    else if (qDv.Type == 'CHECK BOX')
      changedValue = qDv.Name + ' (' + (value == 'True' || value == 'true' || value == '1' ? 'No' : 'Yes') + ')';
    else {
      if (questionName == 'Assessment Comments' || questionName == 'Credit Deficient Comments')
        changedValue = qDv.Value;
      else
        changedValue = qDv.Name + ' : ' + qDv.Value;
    }

    var trackingHistory = new TrackingHistory();
    trackingHistory.ChangedField = sec.SectionID + "," + questionId;
    trackingHistory.ChangedValue = changedValue;

    return trackingHistory;
  }
  setTracking(changedField: string, action: string, changedValue: string[]): TrackingHistory {
    var trackingHistory = new TrackingHistory();
    trackingHistory.ChangedField = changedField;
    trackingHistory.ChangedValue = action + ":" + changedValue.toString();
    return trackingHistory;
  }

  setTrackingHistory2(sec: Section, questionId: number, questionName: string, value: string): TrackingHistory {
    var trackingHistory = new TrackingHistory();
    trackingHistory.ChangedField = sec.SectionID + "," + questionId;
    trackingHistory.ChangedValue = value;

    return trackingHistory;   
  }
  updateSections(sA: Section,questionId:number) {  
    if (this.editCompletedINAForm() || questionId==498 ) {
      this.apiUpdateSection();
    }
  }

  updateCacheSection(sA:Section)
  {
    this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.forEach(element => {
      if (element.SectionID == sA.SectionID) {
        element = sA;
        this.inaService.setCurrentInaSelectionObject(this.inaSchoolEnrollmentSelection);
      }
    });
  }
  editCompletedINAForm() {
    let retVal:boolean=false;
    if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 1) {
      retVal=true;
    }
    else if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 2) {      
      let createdBySection=this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.find(sectionId=>sectionId.SectionID==29);
            let followUpQuestion=createdBySection?.Questions.find(question=>question.Id==498);            
            let followUpFName,followUpLName,followUpDate;
            
            followUpQuestion?.lstQuestionValueDataView.forEach(x=> {
              if(x.Id==1587)                
                  followUpFName=x.Value;                
              else if(x.Id==1588)
                  followUpLName=x.Value;
              else if (x.Id==1589)
                followUpDate=x.Value
            })
            
            if(followUpFName!='' && followUpLName!='' && followUpDate!='')
              retVal=true
    }
    return retVal;
  }

  apiUpdateSection() {
    this.inaService.updateINA(this.inaSchoolEnrollmentSelection.inaSchoolEnrollment).subscribe((inaUpdateResponse: any) => {
      if (inaUpdateResponse.status == 200) {
      }
    });
  }

}



